import * as React from "react";
import { Navigate, useNavigate } from "react-router";
import { useCan, useGetIdentity, useNotification } from "@refinedev/core";
import type { AdminIdentity } from "@/providers/types";
import { ROLE_HOME } from "@/providers/types";

interface RoleRedirectProps {
  resource: string;
  action?: string;
  children: React.ReactNode;
}

export function RoleRedirect({
  resource,
  action = "list",
  children,
}: RoleRedirectProps): React.JSX.Element | null {
  const { data: canData, isLoading } = useCan({ resource, action });
  const { data: identity } = useGetIdentity<AdminIdentity>();
  const navigate = useNavigate();
  const { open } = useNotification();

  React.useEffect(() => {
    if (!isLoading && canData?.can === false) {
      open?.({
        type: "error",
        message: "Раздел недоступен для вашей роли",
      });
      const role = identity?.role;
      const homePath = role ? (ROLE_HOME[role] ?? "/users") : "/users";
      navigate(homePath, { replace: true });
    }
  }, [canData?.can, isLoading, identity?.role, navigate, open]);

  if (isLoading) return null;

  if (canData?.can === false) {
    const role = identity?.role;
    const homePath = role ? (ROLE_HOME[role] ?? "/users") : "/users";
    return <Navigate to={homePath} replace />;
  }

  return <>{children}</>;
}
